import React from "react";
import "../Footer/footer.css";
import { Row } from "reactstrap";
export default function Footer() {
  return (
    < >
    <Row className="footer__item d-lg-flex justify-content-lg-between align-items-lg-center ml-auto ">
    <h4
      className="hidden-sm-down d-none d-lg-block text-md-end"
      style={{ fontFamily: "Poppins", fontSize: "16px", color: "#2C2E34" }}
    >
        Powered by&nbsp;
        <span style={{ color: "#3A3D45",fontFamily:"Poppins" }}>va</span>
        <span style={{ color: "#1796FF", fontFamily:"Poppins"}}>énable</span>
      </h4>
      </Row>
    </>
  );
}